import React from "react";
import SEO from "../../components/SEO";

function Privacidad() {
    return (
        <>
            <SEO
                title="Política de privacidad | Conferencia para Canadá"
                description="Información sobre cómo tratamos tus datos cuando te registras a la Conferencia para Canadá."
                keywords="Privacidad, proteccion de datos, registro conferencia canada"
                ogImage="https://conferenciaparacanada.com/assets/images/og.jpg"
                favicon="https://conferenciaparacanada.com/assets/images/favicon-32x32.png"
                appleFavicon="https://conferenciaparacanada.com/assets/images/apple-touch-icon.png"
            />

            <div className="privacidad">
                <div className="privacidad-header">
                    <div className="container">
                        <h1>Política de privacidad</h1>
                    </div>
                </div>
                <div className="container">
                    <p>
                        Aquí te explicamos qué hacemos con los datos que escribes en el formulario de
                        registro. Al enviarlo aceptas estas condiciones y nos autorizas a contactarte
                        sobre la conferencia.
                    </p>

                    <section>
                        <h2>Datos que solicitamos</h2>
                        <p>En el formulario de registro pedimos cuatro datos:</p>
                        <ul>
                            <li>Tu nombre completo.</li>
                            <li>
                                Tu número de WhatsApp, a 10 dígitos y sin código de país. Al guardarlo le
                                añadimos el prefijo de México (+52).
                            </li>
                            <li>Tu correo electrónico.</li>
                            <li>La ciudad donde asistirás a la conferencia.</li>
                        </ul>
                        <p>
                            Al completar el registro guardamos además la fecha y la hora en que lo hiciste,
                            y un código de pase único, el mismo que viaja dentro del QR de tu correo de
                            confirmación.
                        </p>
                    </section>

                    <section>
                        <h2>Para qué usamos tus datos</h2>
                        <ul>
                            <li>Registrar tu asistencia y apartar tu cupo.</li>
                            <li>Enviarte por correo la confirmación de tu registro y tu pase con código QR.</li>
                            <li>
                                Recordarte por WhatsApp y por correo la fecha, la hora y la sede antes del
                                evento.
                            </li>
                            <li>Responder tus dudas sobre la conferencia.</li>
                            <li>
                                Entregárselos a la institución a la que le muestres tu pase el día del
                                evento, que es lo que le permite enviarte su información después.
                            </li>
                            <li>
                                Frenar los registros automáticos. El formulario lleva un campo oculto y mide
                                cuánto tardas en enviarlo, y ni uno ni otro guardan información adicional
                                sobre ti.
                            </li>
                        </ul>
                    </section>

                    <section>
                        <h2>Base legal y consentimiento</h2>
                        <p>
                            Tratamos tus datos con base en el consentimiento que nos das al enviar el
                            formulario. Puedes retirarlo cuando quieras escribiendo a info@para-canada.com,
                            y hacerlo no afecta el tratamiento que ya hicimos de manera legítima.
                        </p>
                    </section>

                    <section>
                        <h2>Con quién compartimos la información</h2>
                        <p>
                            No vendemos tus datos ni se los entregamos a nadie por iniciativa nuestra.
                            Fuera de nuestro equipo solo los tocan los proveedores que necesitamos para
                            operar el sitio y el registro: el hosting, la plataforma de correo con la que
                            te enviamos las confirmaciones y el servicio que manda los recordatorios por
                            WhatsApp. Todos ellos procesan los datos por nuestra cuenta y bajo
                            obligaciones de confidencialidad.
                        </p>
                        <p>
                            Hay una excepción, y la decides tú: el pase con código QR. Te la explicamos
                            aquí abajo.
                        </p>
                    </section>

                    <section>
                        <h2>El pase con QR y las instituciones invitadas</h2>
                        <p>
                            Al registrarte te enviamos por correo un pase con un código QR. Ese código es
                            la única forma en que tus datos llegan a alguien que los va a usar por su
                            cuenta, y no se activa solo. Hace falta que tú se lo muestres a una
                            institución el día de la conferencia.
                        </p>
                        <p>
                            Cuando lo haces, esa institución recibe exactamente lo que escribiste en el
                            formulario: tu nombre completo, tu número de WhatsApp, tu correo electrónico y
                            la sede a la que asististe. Nada más. A partir de ese momento lo usa para
                            enviarte información sobre sus programas y responde por esos datos por su
                            cuenta.
                        </p>
                        <p>
                            Si no quieres compartir tus datos con una institución, no le muestres el
                            código. Puedes recorrer la conferencia entera sin escanear nada y sin que eso
                            afecte tu entrada ni tu cupo.
                        </p>
                        <p>
                            Guardamos registro de qué instituciones escanearon tu pase. Escríbenos a
                            <a href="mailto:info@para-canada.com"> info@para-canada.com</a> y te decimos
                            cuáles son, para que puedas pedirle a cada una que borre tus datos o que deje
                            de escribirte. Si prefieres, lo pedimos nosotros por ti.
                        </p>
                    </section>

                    <section>
                        <h2>Conservación y seguridad</h2>
                        <p>
                            Guardamos tus datos el tiempo que haga falta para organizar la conferencia,
                            enviarte las confirmaciones y cumplir con las obligaciones legales que
                            correspondan. Mientras tanto los protegemos con medidas de seguridad razonables.
                        </p>
                    </section>

                    <section>
                        <h2>Tus derechos</h2>
                        <p>
                            Puedes pedir acceso a tus datos, corregirlos, eliminarlos u oponerte a que te
                            enviemos comunicaciones. Escribe a
                            <a href="mailto:info@para-canada.com"> info@para-canada.com</a> con el asunto
                            «Privacidad» y cuéntanos qué necesitas. Si lo único que quieres es dejar de
                            recibir mensajes, basta con que lo digas en cualquier respuesta.
                        </p>
                        <p>
                            Esos mismos derechos valen para los datos que ya recibió una institución al
                            escanear tu pase. Escríbenos y te decimos cuáles lo hicieron, o tramitamos la
                            solicitud con ellas por ti.
                        </p>
                    </section>

                    <section>
                        <h2>Contacto</h2>
                        <p>
                            Si tienes dudas sobre esta política o sobre cómo tratamos tus datos, escríbenos
                            a <a href="mailto:info@para-canada.com">info@para-canada.com</a>.
                        </p>
                    </section>
                </div>
            </div>
        </>
    );
}

export default Privacidad;
